module.exports = __webpack_public_path__ + "static/media/files icon-XLS.a5f4cc49.png";